import type { FC } from 'react';
import { PfaWarning } from '../../../../components/pfa-warning';
import { isGiftRegistry, isHardGood, isShipTo } from '../../../../utils/product-utils';
import type { ProductItemEditor } from '../../../../bff-api/baskets/model';

export type CartItemPfaWarningProps = {
    productItem: ProductItemEditor;
};

export const CartItemPfaWarning: FC<CartItemPfaWarningProps> = ({ productItem }) =>
    isShipTo(productItem) || (isGiftRegistry(productItem) && isHardGood(productItem)) ? (
        <PfaWarning
            id={`pfa-cart-message-${productItem.itemId}`}
            alignItems="flex-start"
            containsPfa={Boolean(productItem?.c_containsPfa)}
            stateCode={productItem?.productListItem?.productList?.c_shippingAddress?.stateCode}
        />
    ) : null;
